<cap-list-loader [hasRight]="hasRight" [keineTranslateKey]="keineTranslateKeys" [listLoader]="listLoader" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <div class="table-responsive">
      <table class="cap-table-detail-manual">
        <thead>
          <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
        </thead>
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th style="width: 20%">
      {{ "DatumOderBelegOderEntstehung" | translate }}
    </th>
    <th style="width: 5%">
      {{ "Art" | translate }}
    </th>
    <th style="width: 35%">
      {{ "Bezeichnung" | translate }}
    </th>
    <th style="width: 15%">
      {{ "rechteId" | translate }}
    </th>
    <th style="width: auto">
      @if (showRechtsgrund) {
        {{ "DatumOderBelegOderRechtsgrund" | translate }}
      } @else if (isEigentuemerOrLoggedIn) {
        {{ "DatumRechtsgrund" | translate }}
      }
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (lastRechtRootEntryVm of listLoader?.items; let i = $index; track i) {
    <!-- Kopfzeile -->
    <ng-template
      [ngTemplateOutlet]="kopfzeile"
      [ngTemplateOutletContext]="{
        lastRechtRootEntryVm: lastRechtRootEntryVm,
        odd: i % 2
      }">
    </ng-template>

    <!-- Grundstuecke -->
    @if (showGrundstuecke) {
      @for (lastRechtGrundstueckEntryVm of lastRechtRootEntryVm.oppositeGrundstuckEntries; let last = $last; track $index) {
        <ng-template
          [ngTemplateOutlet]="lastRechtGrundstueck"
          [ngTemplateOutletContext]="{
            lastRechtGrundstueckEntryVm: lastRechtGrundstueckEntryVm,
            odd: i % 2,
            last: last
          }">
        </ng-template>
      }
    }

    <!-- Personen -->
    <ng-template
      [ngTemplateOutlet]="lastRechtPerson"
      [ngTemplateOutletContext]="{
        lastRechtPersonEntriesVm: lastRechtRootEntryVm.oppositePersonEntries,
        odd: i % 2
      }">
    </ng-template>

    <!-- Weitere Informationen -->
    @if (showGehoertZu) {
      <ng-template
        [ngTemplateOutlet]="gehoertZu"
        [ngTemplateOutletContext]="{
          rechtebeziehungen: lastRechtRootEntryVm.rechtebeziehungen,
          odd: i % 2
        }">
      </ng-template>
    }
    @if (showNachgang && lastRechtRootEntryVm.isBelastet) {
      <ng-template
        [ngTemplateOutlet]="nachgang"
        [ngTemplateOutletContext]="{
          rangregelungen: lastRechtRootEntryVm.rangregelungen,
          odd: i % 2
        }">
      </ng-template>
    }
    @if (showBemerkung) {
      <ng-template
        [ngTemplateOutlet]="bemerkung"
        [ngTemplateOutletContext]="{
          standardRechtVersionVm: lastRechtRootEntryVm.standardRechtMasterVm.lastVersion,
          odd: i % 2
        }"></ng-template>
    }

    @if (showVertragtext) {
      <ng-template
        [ngTemplateOutlet]="vertragtext"
        [ngTemplateOutletContext]="{
          standardRechtVersionVm: lastRechtRootEntryVm.standardRechtMasterVm.lastVersion,
          odd: i % 2
        }">
      </ng-template>
    }
  }
</ng-template>

<ng-template #kopfzeile let-lastRechtRootEntryVm="lastRechtRootEntryVm" let-odd="odd">
  @for (versionVm of lastRechtRootEntryVm.standardRechtMasterVm.versionenVm; let last = $last; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      <td>
        <div [capHistinfo]="versionVm.histInfo">
          @if (isEigentuemerOrLoggedIn) {
            {{ versionVm.object.beginndatum | datum }}
          }
          <cap-kompakt-beleg
            [enableNavigation]="isGeschaeftsmodulCapWebErweiterung"
            [histInfo]="versionVm.histInfo"
            [item]="versionVm.object.beleg"
            [referenzObjectId]="versionVm.object?.id?.id"
            [referenzObjectType]="'STANDARDRECHT'"></cap-kompakt-beleg>
        </div>
      </td>
      <td>
        <div [capHistinfo]="versionVm.histInfo">
          <span>
            {{ lastRechtRootEntryVm.belastungsartKurz | translate }}
          </span>
        </div>
      </td>
      <td>
        <div>
          <cap-kompakt-standardrecht
            [histInfo]="versionVm.histInfo"
            [recht]="lastRechtRootEntryVm.object"
            [textLimit]="200"
            [version]="versionVm.object">
          </cap-kompakt-standardrecht>
          <cap-kompakt-timepoint [item]="versionVm.object.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </div>
      </td>
      <td>
        <div [capHistinfo]="versionVm.histInfo" class="text-nowrap">
          <span>
            <cap-link
              [enableNavigation]="enableNavigation"
              [queryParams]="versionVm.getQueryParams()"
              [target]="navTargets.NAV_RECHT"
              [tooltipParams]="{
                art: lastRechtRootEntryVm.object.rechtArt | translate
              }">
              {{ lastRechtRootEntryVm.standardRechtMasterVm.object.rechteId | formatRechteId }}
            </cap-link>
            @if (enableNavigation) {
              <cap-maps
                [mapType]="lastRechtRootEntryVm.standardRechtMasterVm?.object.rechtArt"
                [model]="lastRechtRootEntryVm.standardRechtMasterVm?.lastVersion?.object"
                [tooltip]="lastRechtRootEntryVm.standardRechtMasterVm?.object.rechtArt | translate"></cap-maps>
            }
          </span>
        </div>
      </td>
      <td>
        @if (showRechtsgrund) {
          @if (lastRechtRootEntryVm.rechtsgruende && last) {
            @for (rechtsgrund of lastRechtRootEntryVm.rechtsgruende; track $index) {
              @if (rechtsgrund && rechtsgrund.histInfo) {
                <p class="mb-0">
                  <cap-rechtsgrund-icp [rechtsgrund]="rechtsgrund" [showBeleg]="showRechtsgrund"></cap-rechtsgrund-icp>
                </p>
              }
            }
          }
        }
      </td>
    </tr>
  }
</ng-template>

<ng-template #lastRechtGrundstueck let-last="last" let-lastRechtGrundstueckEntryVm="lastRechtGrundstueckEntryVm" let-odd="odd">
  <tr [ngClass]="{ even: !odd, odd: odd }">
    <td></td>
    <td></td>
    <td [ngClass]="{ 'p-0': true, abstandUnten: last }">
      <div class="ps-4 mt-1">
        <span>
          <span [capHistinfo]="lastRechtGrundstueckEntryVm.histInfo">
            {{ lastRechtGrundstueckEntryVm.belastungsartKurz | translate }}
            <cap-kompakt-grundstueck [item]="lastRechtGrundstueckEntryVm.object.grundstueck" [navigateTo]="grundstueckNavTarget">
            </cap-kompakt-grundstueck>
          </span>
          <cap-kompakt-timepoint [item]="lastRechtGrundstueckEntryVm.object.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
        </span>
      </div>
    </td>
    <td></td>
    <td [ngClass]="{ 'p-0': true, abstandUnten: last }">
      @if (showRechtsgrund || isEigentuemerOrLoggedIn) {
        @for (rechtsgrund of lastRechtGrundstueckEntryVm.rechtsgruende; track $index) {
          @if (rechtsgrund && rechtsgrund.histInfo) {
            <p class="mb-0">
              <cap-rechtsgrund-icp [rechtsgrund]="rechtsgrund" [showBeleg]="showRechtsgrund"></cap-rechtsgrund-icp>
            </p>
          }
        }
      }
    </td>
  </tr>
</ng-template>

<ng-template #lastRechtPerson let-lastRechtPersonEntriesVm="lastRechtPersonEntriesVm" let-odd="odd">
  <!-- Personen Versionen -->
  @for (lastRechtPersonEntryVm of lastRechtPersonEntriesVm | orderByLastRechtPersonEntryVm; track $index) {
    @if (!lastRechtPersonEntryVm.isAuskunftGesperrt || isEigentuemer) {
      @for (version of lastRechtPersonEntryVm.person?.versions; let last = $last; track $index) {
        <tr [ngClass]="{ even: !odd, odd: odd }">
          <td></td>
          <td></td>
          <td>
            <div class="ps-4">
              <span [capHistinfo]="lastRechtPersonEntryVm.person?.histInfo">
                <span [capHistinfo]="version?.histInfo"
                  >{{ "ZuGunsten" | translate }}
                  <cap-kompakt-persongb
                    [auskunftsperre]="version.auskunftsperre"
                    [capHistinfo]="version.histInfo"
                    [enableNavigation]="enableNavigation"
                    [isEigentuemer]="isEigentuemer"
                    [item]="version"
                    [itemMasterId]="lastRechtPersonEntryVm.person.id">
                  </cap-kompakt-persongb>
                  @if (lastRechtPersonEntryVm.personStamm?.adressen[0] && (!lastRechtPersonEntryVm.isAddresseGesperrt || isEigentuemer)) {
                    <cap-kompakt-personenadresse
                      [auskunftsperre]="lastRechtPersonEntryVm.personStamm?.auskunftsperre"
                      [entry]="lastRechtPersonEntryVm.personStamm?.version"
                      [format]="'PERSONENADRESSE_TYP01'"
                      [isEigentuemer]="isEigentuemer"
                      [item]="lastRechtPersonEntryVm.personStamm?.adressen[0]">
                    </cap-kompakt-personenadresse>
                  }
                  @if (lastRechtPersonEntryVm.isAddresseGesperrt && !isEigentuemer) {
                    {{ "persongb.addresssperre" | translate }}
                  }
                </span>
              </span>
              <cap-kompakt-timepoint [item]="lastRechtPersonEntryVm.person?.histInfo" loeschgeschaeft></cap-kompakt-timepoint>
            </div>
          </td>
          <td></td>
          <td class="pt-1">
            @if (showRechtsgrund || isEigentuemerOrLoggedIn) {
              @if (last) {
                @for (rechtsgrund of lastRechtPersonEntryVm.object.rechtsgruende; track $index) {
                  @if (rechtsgrund && rechtsgrund.histInfo) {
                    <p class="mb-0">
                      <cap-rechtsgrund-icp [rechtsgrund]="rechtsgrund" [showBeleg]="showRechtsgrund"></cap-rechtsgrund-icp>
                    </p>
                  }
                }
              }
            }
          </td>
        </tr>
      }
    } @else {
      <!-- Personen mit Auskunftssperre (Versionen platt gemacht)-->
      @if (lastRechtPersonEntryVm.person) {
        <tr [ngClass]="{ even: true }">
          <td></td>
          <td></td>
          <td>
            <div class="ps-4">
              <span [capHistinfo]="lastRechtPersonEntryVm.person?.histInfo">
                {{ "ZuGunsten" | translate }}
                <span style="font-style: italic">
                  {{ "persongb.auskunftssperre" | translate }}
                </span>
              </span>
              <cap-kompakt-timepoint [item]="lastRechtPersonEntryVm.person?.histInfo" loeschgeschaeft></cap-kompakt-timepoint>
            </div>
          </td>
          <td></td>
          <td class="pt-1">
            @if (showRechtsgrund) {
              @if ($last) {
                @for (rechtsgrund of lastRechtPersonEntryVm.object.rechtsgruende; track $index) {
                  @if (rechtsgrund && rechtsgrund.histInfo) {
                    <p class="mb-0">
                      <cap-rechtsgrund-icp [rechtsgrund]="rechtsgrund" [showBeleg]="showRechtsgrund"></cap-rechtsgrund-icp>
                    </p>
                  }
                }
              }
            }
          </td>
        </tr>
      }
    }
  }
</ng-template>

<ng-template #gehoertZu let-odd="odd" let-rechtebeziehungen="rechtebeziehungen">
  @for (beziehung of rechtebeziehungen; let first = $first; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      <td class="table-subelements">
        @if (first) {
          {{ "gehoertZu" | translate }}:
        }
      </td>
      <td></td>
      <td>
        @if (beziehung.object.recht.art === "PFANDRECHT") {
          <cap-kompakt-grundpfandrecht-icp
            [histInfo]="beziehung.object.histInfo"
            [masterId]="beziehung.object.recht.id"
            [rechteId]="beziehung.object.recht.rechteId"
            [version]="beziehung.object.recht.version"
            format="GRUNDPFANDRECHT_TYP01">
          </cap-kompakt-grundpfandrecht-icp>
        } @else {
          <cap-kompakt-standardrecht
            [histInfo]="beziehung.object.histInfo"
            [recht]="beziehung.object.recht"
            [textLimit]="200"
            format="STANDARDRECHT_TYP01">
          </cap-kompakt-standardrecht>
        }
        @if (!beziehung.object.isSelfReference) {
          <span [capHistinfo]="beziehung.object.histInfo">
            {{ "auf" | translate }}
          </span>
          <cap-kompakt-grundstueck
            [capHistinfo]="beziehung.object.histInfo"
            [item]="beziehung.object.grundstueck"
            [navigateTo]="grundstueckNavTarget">
          </cap-kompakt-grundstueck>
        }
      </td>
      <td></td>
      <td></td>
    </tr>
  }
</ng-template>

<ng-template #nachgang let-odd="odd" let-rangregelungen="rangregelungen">
  @for (rangregelung of rangregelungen; track $index) {
    <tr [ngClass]="{ even: !odd, odd: odd }">
      @if (rangregelung.object.geschaeftsnummer) {
        <td class="table-subelements">
          {{ $first ? ("imNachgangZu" | translate) : "" }}
        </td>
        <td></td>
        <td>
          @if (rangregelung.object.vorgaengerMaster?.art === "PFANDRECHT") {
            <cap-kompakt-grundpfandrecht-icp
              [histInfo]="rangregelung.object.histInfo"
              [masterId]="rangregelung.object.vorgaengerMaster.id"
              [rechteId]="rangregelung.object.vorgaengerMaster.rechteId"
              [version]="rangregelung.object.vorgaengerMaster.version"
              format="GRUNDPFANDRECHT_TYP01">
            </cap-kompakt-grundpfandrecht-icp>
          } @else {
            <cap-kompakt-standardrecht
              [format]="rangregelung.object.format"
              [histInfo]="rangregelung.object.histInfo"
              [recht]="rangregelung.object.vorgaengerMaster"
              [textLimit]="200">
            </cap-kompakt-standardrecht>
          }
          @if (!rangregelung.isSelfReference && rangregelung.object.grundstueck) {
            <span [capHistinfo]="rangregelung.object.histInfo">
              {{ "auf" | translate }}
            </span>
            @if (rangregelung.object.grundstueck) {
              <cap-kompakt-grundstueck
                [capHistinfo]="rangregelung.object.histInfo"
                [item]="rangregelung.object.grundstueck"
                [navigateTo]="grundstueckNavTarget">
              </cap-kompakt-grundstueck>
            }
          }
        </td>
        <td></td>
        <td class="pt-0">
          @if (showRechtsgrund) {
            @if (rangregelung.object.belegEntry) {
              <cap-kompakt-beleg-icp
                [histInfo]="rangregelung.object.histInfo"
                [item]="rangregelung.object.belegEntry"
                [referenzObjectId]="rangregelung.object.vorgaengerMaster?.id?.id"
                [referenzObjectType]="rangregelung.object.vorgaengerMaster?.art"
                format="BELEG_TYP03"></cap-kompakt-beleg-icp>
            }
          }
        </td>
      }
    </tr>
  }
</ng-template>

<ng-template #bemerkung let-odd="odd" let-standardRechtVersionVm="standardRechtVersionVm">
  <tr [ngClass]="{ even: !odd, odd: odd }">
    @if (standardRechtVersionVm.hasOeffentlicheOrNichtOeffentlicheBemerkungen) {
      <td class="table-subelements">{{ "Bemerkungen" | translate }}</td>
      <td></td>
      <td colspan="2">
        @if (standardRechtVersionVm.hasNichtOeffentlicheBemerkungen) {
          <cap-read-more
            [histInfo]="standardRechtVersionVm.histInfo"
            [limit]="100"
            [text]="standardRechtVersionVm.object.bemerkung"></cap-read-more>
           <br />
          <div class="d-flex align-items-start ps-20 mb-0">
            <span class="table-subelements me-2">{{ "nicht.oeffentliche.bemerkung" | translate }}</span>
          <cap-read-more
            [histInfo]="standardRechtVersionVm.histInfo"
            [limit]="100"
            [text]="standardRechtVersionVm.object.bemerkungNichtOeffentlich"></cap-read-more>
          </div>
        } @else {
          <cap-read-more [histInfo]="standardRechtVersionVm.histInfo" [limit]="100" [text]="standardRechtVersionVm.object.bemerkung">
          </cap-read-more>
        }
      </td>
      <td></td>
    }
  </tr>
</ng-template>

<ng-template #vertragtext let-odd="odd" let-standardRechtVersionVm="standardRechtVersionVm">
  <tr [ngClass]="{ even: !odd, odd: odd }">
    @if (standardRechtVersionVm.object.vertragstext) {
      <td class="table-subelements">{{ "Vertragstexte" | translate }}</td>
      <td></td>
      <td colspan="3">
        <cap-read-more
          [histInfo]="standardRechtVersionVm.object.histInfo"
          [limit]="200"
          [text]="standardRechtVersionVm.object.vertragstext">
        </cap-read-more>
      </td>
    }
  </tr>
</ng-template>
